import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Shield } from "lucide-react";

const COOKIE_CONSENT_KEY = "beam_cookie_consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (consent === "accepted") {
      loadTrackingScript();
    } else if (!consent) {
      // Show banner after a short delay so it doesn't flash on load
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setVisible(false);
    loadTrackingScript();
  };

  const decline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 left-0 right-0 z-[9999] p-4 md:p-6"
        >
          <div className="max-w-3xl mx-auto bg-card-gradient border border-card-foreground/10 rounded-2xl p-5 md:p-6 shadow-[0_-8px_40px_-10px_rgba(0,0,0,0.25)] backdrop-blur-sm">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <div className="flex items-start gap-3 flex-1">
                <Shield className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                <div>
                  <p className="text-card-foreground text-sm font-medium leading-relaxed">
                    We use cookies and similar technologies to improve your experience. By continuing, you agree to our{" "}
                    <a href="/privacy-policy" className="text-primary hover:underline">Privacy Policy</a>.
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 shrink-0 w-full sm:w-auto">
                <button
                  onClick={decline}
                  className="flex-1 sm:flex-none text-card-foreground/60 hover:text-card-foreground text-sm font-medium px-4 py-2 rounded-full transition-colors"
                >
                  Decline
                </button>
                <button
                  onClick={accept}
                  className="flex-1 sm:flex-none bg-primary text-primary-foreground text-sm font-heading font-bold px-5 py-2 rounded-full hover:bg-primary/90 transition-colors"
                >
                  Accept
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

function loadTrackingScript() {
  if (document.getElementById("vtag-ai-js")) return;
  const script = document.createElement("script");
  script.id = "vtag-ai-js";
  script.async = true;
  script.src = "https://r2.leadsy.ai/tag.js";
  script.dataset.pid = "wvdF8bsn5wkustL2";
  script.dataset.version = "062024";
  document.head.appendChild(script);
}
